import React from 'react';
import { Heading, SubHeading } from '../../typography';
import { Container, HeaderContainer, PromoteTabs, ProductsTabs } from './PromoteHeader.style';

interface PromoteHeaderProps {
  products?: boolean;
  propertyId?: string;
}

const PromoteHeader: React.FC<PromoteHeaderProps> = ({ products, propertyId }) => {
  return (
    <Container data-testid="promote-header">
      <HeaderContainer>
        <Heading fontSize={40}>Make Your Property Stand Out</Heading>
        <SubHeading fontSize={24} fontWeight="400">
          Enhance your property&apos;s visibility with our premium advertising options. These upgrades help your listing
          attract more attention and drive interest. Choose the best option below to get your property noticed.
        </SubHeading>
      </HeaderContainer>
      {products ? (
        <ProductsTabs data-testid="products-tabs" />
      ) : (
        <PromoteTabs data-testid="promote-tabs" propertyId={propertyId} />
      )}
    </Container>
  );
};

export default PromoteHeader;
